import { render, staticRenderFns } from "./projects_dropdown.vue?vue&type=template&id=4aefd617&vue3"
import script from "./projects_dropdown.vue?vue&type=script&lang=js&vue3"
export * from "./projects_dropdown.vue?vue&type=script&lang=js&vue3"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports